export default {
  gas: 'Dried - Gas / Diesel Oil',
  kerosene: 'Dried - Kerosene',
  naturalGas: 'Dried - Natural Gas',
  lpg: 'Dried - LPG (Propane)',
  aerated: 'Aerated',
  adesco: 'Adesco Treated',
};
